import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import { getNestedObject } from '../../lib/util'

const SearchCriteriaBadge = ({ clearSearch, criteria }) => {
  return (
    <div>
      <p>
        Search Criteria:&nbsp;
        {Object.keys(criteria).map(key => {
          return (
            <span className="criteria" key={key}>
              <Badge
                color="info"
                style={{ fontSize: 'inherit', marginRight: '0.5rem' }}
              >
                {key}: <span className="value">{criteria[key]}</span>
                <span
                  className="remove"
                  data-testid={`remove-clear-search-${key}`}
                  onClick={clearSearch}
                >
                  &times;
                </span>
              </Badge>
              <style jsx>
                {`
                  .criteria {
                    font-weight: inherit;
                  }
                  .value {
                    font-weight: bold;
                  }
                  .remove {
                    cursor: pointer;
                    margin-left: 0.25rem;
                  }
                `}
              </style>
            </span>
          )
        })}
      </p>
    </div>
  )
}

SearchCriteriaBadge.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  criteria: PropTypes.object.isRequired,
}

function mapStateToProps(state, { managerType }) {
  const manager = getNestedObject(state, managerType)
  return {
    criteria: manager.criteria,
  }
}

export default connect(mapStateToProps)(SearchCriteriaBadge)



// WEBPACK FOOTER //
// ./src/components/SearchCriteriaBadges/component.js